/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/TasksCreateForm/Patient/Content/SearchResult/Loading"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 delay={1000}
 width={dtSpaceS}
 height={dtSpaceS}
/>
</div>
{children}
</React.Fragment>)
}